import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, KeyRound, ScrollText, LogOut, MoonStar, UserCog } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/", label: "Panel", icon: LayoutDashboard, testid: "nav-panel", end: true },
  { to: "/informes", label: "Informes", icon: FileText, testid: "nav-informes" },
  { to: "/claves", label: "Claves API", icon: KeyRound, testid: "nav-claves" },
  { to: "/auditoria", label: "Auditoría", icon: ScrollText, testid: "nav-auditoria" },
  { to: "/cuenta", label: "Cuenta", icon: UserCog, testid: "nav-cuenta" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors duration-150 ${
      isActive ? "bg-[#1a1d29] text-white border border-[#3b4259]" : "text-slate-400 hover:text-white hover:bg-[#1a1d29]/60 border border-transparent"
    }`;

  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      <aside className="hidden md:flex md:w-60 flex-col border-r border-[#232838] bg-[#0c0e15] p-4 sticky top-0 h-screen">
        <div className="flex items-center gap-2.5 px-2 py-4">
          <MoonStar className="w-6 h-6 text-[#8b5cf6]" />
          <div>
            <div className="font-bold text-sm leading-tight" style={{ fontFamily: "Syne, sans-serif" }}>Observatorio</div>
            <div className="text-[10px] font-mono2 uppercase tracking-widest text-slate-500">Nightlife Milano</div>
          </div>
        </div>
        <nav className="mt-6 space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={linkCls} data-testid={n.testid}>
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[#232838] pt-4 space-y-2">
          <div className="px-2 text-xs text-slate-500 truncate" data-testid="sidebar-user-email">{user?.email}</div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-slate-400 hover:text-red-400 hover:bg-[#1a1d29]/60 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 pb-20 md:pb-0">
        <header className="md:hidden sticky top-0 z-20 bg-[#0c0e15]/95 backdrop-blur border-b border-[#232838] px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <MoonStar className="w-5 h-5 text-[#8b5cf6]" />
            <span className="font-bold text-sm" style={{ fontFamily: "Syne, sans-serif" }}>Observatorio Milano</span>
          </div>
          <button onClick={handleLogout} data-testid="logout-button-mobile" className="text-slate-400 hover:text-red-400 p-2">
            <LogOut className="w-4 h-4" />
          </button>
        </header>
        <main className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-20 bg-[#0c0e15]/95 backdrop-blur border-t border-[#232838] flex justify-around py-2">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`${n.testid}-mobile`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-1 text-[10px] ${isActive ? "text-[#8b5cf6]" : "text-slate-500"}`
            }
          >
            <n.icon className="w-5 h-5" />
            {n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
